import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {ServicoVinculado} from '../../../model/catalogo';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'servico-modal',
    templateUrl: './servico-modal.component.html',
    styleUrls: ['./servico-modal.component.css']
})
export class ServicoModalComponent {

    constructor(private globalService: GlobalService, public modalService: ModalService, public pesquisaService: PesquisasFiltroApiService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    private sub: any;

    campoBusca = new FormControl('', []);
    resultado: Array<ServicoVinculado> = null;
    selecionados: Array<ServicoVinculado> = new Array<ServicoVinculado>();
    mensagemErro: string = '';

    servicoModalForm: FormGroup = this.formBuilder.group({
        campoBusca: this.campoBusca
    });

    ngOnInit() {
        this.mensagemErro = '';
        this.campoBusca.setValue('');

        this.sub = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                if (params['campoBusca'] != '') {
                    this.campoBusca.setValue(params['campoBusca']);
                }
                if (params['selecionados'] != '') {
                    this.selecionados = JSON.parse(params['selecionados']);
                }
                this.pesquisar();
            });
    }

    pesquisar() {
        let filtros: Array<any> = new Array<any>();
        let filtroAlteracaoEstado: any;

        filtros.push({'filtroServico': {'nome': this.campoBusca.value}});
        filtroAlteracaoEstado = {};

        this.pesquisaService.filtraServico(filtros)
            .subscribe(
                listaServicos => {
                    this.resultado = listaServicos as Array<ServicoVinculado>;
                },
                erro => {
                    if (erro.status == 404) {
                        this.resultado = new Array<ServicoVinculado>();
                    }
                }
            );
    }

    adicionarServico(servico: ServicoVinculado) {
        let existe = false;
        for (var i = 0; i < this.selecionados.length; i++) {
            if (this.selecionados[i].codigo == servico.codigo) {
                existe = true;
                break;
            }
        }
        if (!existe) {
            this.selecionados.push(servico as ServicoVinculado);
        }
    }

    removeServico(servico: ServicoVinculado) {
        this.selecionados.splice(this.selecionados.indexOf(servico), 1);
    }

    confirmar() {
        this.modalService.incluirDadosGerados(this.selecionados);
        this.modalService.fecharPaginaModal();
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/servico-modal/servico-modal.component.ts